var amdi18n={"__root":{"java_not_supported":"Java is not supported","app_not_available":"Open eCard App is not available","platform_not_supported":"Open eCard App doesn't support the current platform","authentication_option_not_supported":"Open eCard App doesn't support the given authentication option","started":"Webstart recovery strategy started","succeeded":"Webstart recovery strategy succeeded","failed":"Webstart recovery strategy failed","stopped":"Webstart recovery strategy stopped","description":"You may download the <a href=\"https://www.openecard.org/en/startpage/\" target=\"_blank\">Open eCard App</a> here."},"__de":{"description":"Hier kann die <a href=\"https://www.openecard.org/startseite/\" target=\"_blank\">Open eCard App</a> herunterladen werden."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/model/recoverystrategy/nls/WebstartRecoveryStrategy_strings.js
// module id = 292
// module chunks = 3